import C from './Constants';
import { formatCurrency } from '../../functions';
import Hammer from 'hammerjs';

import { gsap, Power2 } from 'gsap';
import Draggable from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default class ChooseSeats {
  constructor(props) {
    this.props = props;

    if (!$('.seat-suggestion').length || $(".seatfirst-arena").length) {
        return false;
    }
    this.el = $(".seat-selection");
    this.button = this.el.find('.options .btn-find-tickets');
    this.ticketsHeader = this.el.find('.seat-selection .header h5 span');
    this.seatsContainer = this.el.find('.seats');
    this.borderCompensate = this.el.find('.border-compensate');

    this.section = null;
    this.sectionData = null;
    this.oitemsInSection = null;

    this.availableSeats = null;
    this.listedSeats = [];
    this.groupedSeats = [];
    this.ungroupedSeats = [];
    this.ungroupedIndex = 0;
    this.confirmedSeats = null;
    
    this.seatDistancing = window.arenaInfo.fdSeating;
    if (this.seatDistancing == undefined || this.seatDistancing == null) { this.seatDistancing = 0; }
    
    $('.section-seats').on('click', this._clearError);
    $('.section-container .error').on('click', this._clearError);

    this.dataStorage = this.props.dataStorage;
    this.state = this.dataStorage.state;

    // Binder om this 
    this._getNextSeatableIndex = this._getNextSeatableIndex.bind(this);
    this._onSectionDataLoaded = this._onSectionDataLoaded.bind(this);
    this._onSectionDataLoadError = this._onSectionDataLoadError.bind(this);
    this._onReserveSeatsComplete = this._onReserveSeatsComplete.bind(this);
    this._onReserveSeatsError = this._onReserveSeatsError.bind(this);
    this._selectHoveredSeats = this._selectHoveredSeats.bind(this);
    this._hoverSeatsOnMap = this._hoverSeatsOnMap.bind(this); 
    this._onWheel = this._onWheel.bind(this);
    this.resetViewport = this.resetViewport.bind(this);
    this.updateMiniMapMarker = this.updateMiniMapMarker.bind(this);
    this.btnZoom = this.btnZoom.bind(this);      
    this._onPinch = this._onPinch.bind(this);
    this._onPinchStart = this._onPinchStart.bind(this);
    this._onPinchEnd = this._onPinchEnd.bind(this);    
    this._toggleMiniMap = this._toggleMiniMap.bind(this);
    this._loadSeatsOnMap = this._loadSeatsOnMap.bind(this);
    this.svg = document.querySelector("#svg");
    this.svg.addEventListener("wheel", this._onWheel);   
    $(".btnZoom").on("click", this.btnZoom);
    $("#btnToggleMap").on("click", this._toggleMiniMap);
      
    
      

    // FOR MOBILE PINCH
    // =========================================================================== 
    this.isPinching = false;
    this.PinchCnt = 0;
    this.tPinching = null;
    this.startPinchPos = {};
    this.hammer = new Hammer(this.svg, { domEvents: true });
    this.hammer.get('pinch').set({ enable: true });
     
    this.hammer.on('pinchstart', this._onPinchStart);       
    this.hammer.on('pinch', this._onPinch);       
    this.hammer.on('pinchend', this._onPinchEnd);
      

    // VARIABLES
    this.proxy = document.createElement("div");              
    this.viewBox = this.svg.viewBox.baseVal;
    this.svgMini = document.querySelector("#mapmini");
    this.mapMarker = document.querySelector("#mapMarker");
    this.viewBoxMini = this.svgMini.viewBox.baseVal;
    this.isDragging = false;
    this.lastPickedSeat = "";

    this.freeAllSeatsLimit = 0;
    this.useSeatsLimitRule = true;
    this.poi = null;

    
  }

    

   //
   //  PUBLIC: Updates Seats from datastorage
   //=========================================
  bind() {

    // Called to update
    if ($("#ChooseSeats-Component").is(":visible")) {
      this._loadSeatsOnMap();
      
    } else {
      this.section = null;
      this.sectionData = null;
      $('.poi-bottom').hide();
      $('.poi-top').hide();
    }

    
  }

   //
   //  PUBLIC: LOAD VIEW AFTER GETTING SEATS
   //=========================================
  loadSection(section, poi) {
    this._showLoader();
    // Loaded here when clicking on the arena map
    this.el.show();

    if (!section) {
      return false;
    }

    this.section = section;
    this.poi = poi;

    const arrowAngle = this._getArrowAngle(poi);

     
    // Field below
    this.seatRotation = arrowAngle;

    if (arrowAngle) {
      const neutralArrowRotation = 90;
      if ((arrowAngle + neutralArrowRotation) >= 0 && (arrowAngle + neutralArrowRotation) <= 180) {
        $('.poi-bottom').show();
        $('.poi-top').addClass("whitebg")
      } else {
        $('.poi-bottom').hide();
        $('.poi-top').show();
        $('.poi-top').removeClass("whitebg")
      }

      $('.poi img').each(function () {
        $(this).css({ 'transform': 'rotate(' + arrowAngle + 'deg)' });
      });
    } else {
      $('.poi-bottom, .poi-top').hide();
    }

    const url = C.STATIC_FILES ? C.SECTION_DATA_URL_STATIC : C.BASE_URL + C.SECTION_DATA_URL + section.code;
    $.ajax({
      dataType: 'json',
      url: url,
      data: {},
      success: this._onSectionDataLoaded,
      error: this._onSectionDataLoadError
    });
  }

  _onSectionDataLoadError(xhr, status, error) {
    let errorEl = $('.section-container .error');
    errorEl.show();
  }

  _clearError() {
        let errorEl = $('.section-container .error');
        errorEl.hide();       
  }

   //
   //  LOAD VIEW AFTER GETTING SEATS
   //=========================================
  _onSectionDataLoaded(data, textStatus, xhr) {

    this.sectionData = data && data.length ? this._getDataByEventId(data) : null;            
    if (!this.sectionData) {
      return false;
    }
      
    this.dataStorage.sectionData = this.sectionData;
    let allowedOitems = this.section.oitems;
    this.oitemsInSection = this.sectionData.orderItems.filter(function (x) {
      return allowedOitems.includes(x);
    });

    if (parseInt(xhr.status) !== 200) {
      this._onSectionDataLoadError(null, null, 'no 200 response code');
      return false;
    } else if (!this.sectionData || !this.sectionData.seats || !this.sectionData.seats.length) {
      this._onSectionDataLoadError(null, null, 'no-data or no-seats');
      return false;
    }

    this._checkUngroupedOption(this.sectionData.orderItems.length);

    this.point = this.svg.createSVGPoint();
    this.startClient = this.svg.createSVGPoint();
    this.startGlobal = this.svg.createSVGPoint();

    this._hideLoader();

  
    let cntOwn = this.dataStorage.GetCountInCurrentSection(this.section.code);
        
    console.log("-----------------------");
    if (this.section.ssrl != undefined &&  this.section.ssrl != null && !isNaN(this.section.ssrl)) {
      this.freeAllSeatsLimit = this.section.ssrl * this.sectionData.seats.length / 100;      
      this.useSeatsLimitRule = this.freeAllSeatsLimit < this.sectionData.seats.filter(function (s) { return s.available }).length + cntOwn;    
      console.log("SectionRule - Limit: ", this.section.ssrl + "%,  Total count seats in section: ", this.sectionData.seats.length);
      console.log("Use rule", this.useSeatsLimitRule)
      console.log(" ( Caluculated limit: ", this.freeAllSeatsLimit, " < Count free seats: ", this.sectionData.seats.filter(function (s) { return s.available }).length + " + Own seated: " + cntOwn + " )")
    } else {
      if (window.arenaInfo.ssrl!=undefined && window.arenaInfo.ssrl != null && !isNaN(window.arenaInfo.ssrl)) {
        this.freeAllSeatsLimit = window.arenaInfo.ssrl * this.sectionData.seats.length / 100; 
        this.useSeatsLimitRule = this.freeAllSeatsLimit < this.sectionData.seats.filter(function (s) { return s.available }).length + cntOwn;
        
        console.log("Global/ArenaRule - Limit: ", window.arenaInfo.ssrl + "%,  Totalt count seats in section: ", this.sectionData.seats.length);
        console.log("Use rule: ", this.useSeatsLimitRule)
        console.log(" ( Calculated limit: ", this.freeAllSeatsLimit, " < Count free seats: ", this.sectionData.seats.filter(function (s) { return s.available }).length + " + Own seated: " + cntOwn + " )")
      } else {
        this.useSeatsLimitRule = false;
        console.log("NoRule");
      }
    }
    console.log("-----------------------");
     
    // get seats for section   
    this.mapWidth = 0;
    this.mapHeight = 0;
    this.padding = { x: 100, y:100 };
    
    var displayAreaWidth = $(".section-container")[0].clientWidth;
    var displayAreaHeight = $(".section-container")[0].clientHeight;
    if (!displayAreaWidth) return; // If the view is not visible/loaded

    var displayRatio = displayAreaWidth / displayAreaHeight;
    var displayLeftMargin = 0;
    var displayTopMargin = 0;
   

    this.mapWidth = this.section.dimensions.x + 20;
    this.mapHeight = this.section.dimensions.y + 20;
    var mapRatio = this.mapWidth / this.mapHeight;
    
    this.mapWidth = this.mapHeight * displayRatio;
    if (this.mapWidth < this.section.dimensions.x) {        
        this.mapWidth = this.section.dimensions.x + 20;
        this.mapHeight = this.mapWidth / displayRatio;
    }

    // Adjust SVG after display area
    displayLeftMargin = (this.mapWidth - this.mapHeight * mapRatio) / 2;


      displayLeftMargin = Math.max(0, displayLeftMargin);
      displayTopMargin = Math.max(0, displayTopMargin);
     
    $(".section-seats")[0].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");
    $(".section-seats")[1].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");

      this.isIOS12 = false;
      this.isIOS = false;
       

    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        try {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);            
            if (parseInt(v[1], 10) == "12") this.isIOS12 = true;           
        } catch (e) {            
        }
      }


      this._loadSeatsOnMap();
      
      
      this.dragCnt = 0;
      // reset position
      this.viewBox.x = 0;
      this.viewBox.y = 0;

      this.viewBox.width = this.mapWidth;
      this.viewBox.height = this.mapHeight;
      this.viewBoxMini.width = this.mapWidth;
      this.viewBoxMini.height = this.mapHeight;

      this.isDragging = false;
      this.tDrag;

      this.cachedViewBox = {
          x: this.viewBox.x,
          y: this.viewBox.y,
          width: this.viewBox.width,
          height: this.viewBox.height
      };
      
      window.thisWasThis = this;
      this.zoom = {
          animation: gsap.timeline(),
          scaleFactor: 1.6,
          duration: 0.5,
          ease: Power2.easeOut,
      };
     
      var _this = this;
      this.pannable = new Draggable(this.proxy, {
          throwResistance: 3000,
          minimumMovement: 6,
          allowNativeTouchScrolling: false,
          trigger: this.svg,
          throwProps: true,                    
          onPress: function (e) {
              if (this.isIOS12 && this.isPinching) { return; }
              _this.selectDraggable(e, _this, this);
          },
          onDrag: function () {
              if (this.isIOS12 && this.isPinching) { return; }              
              _this.dragCnt += 1;
              _this.isDragging = true;                            
              _this._onDrag(_this, this)
          },
          onThrowUpdate: function () {
              if (this.isIOS12 && this.isPinching) { return; }
              _this._onDrag(_this, this);
          },
          onDragStart: function () {
              if (this.isIOS12 && this.isPinching) { return; }              
              _this.dragCnt = 0;              
          },
          onDragEnd: function () {
              setTimeout(function () {                  
                  _this.isDragging = false;                   
                  _this.dragCnt = 0;
              }, 100);            
          },
          onRelease: function () {
              setTimeout(function () {
                  _this.isDragging = false;
                  _this.dragCnt = 0;
              }, 100);
          }
      });

      this.pannableMini = new Draggable(this.mapMarker, {
          throwResistance: 3000,
          trigger: "#miniMap",
          bounds: "#miniMap",
          throwProps: true,
          onDrag: function () { _this.updateMiniMap(_this, this) },
          onThrowUpdate: function () { _this.updateMiniMap(_this, this) }
      });

    this.updateMiniMapMarker();
    this._hideLoader();
  }
    
  _getDataByEventId(data) {
    let eventId = parseInt($('.seat-suggestion').data('event-id'));
    if (!eventId || isNaN(eventId)) {
      return false;
    }

    let i = data.length;
    while (i--) {
      let event = data[i];
      if (event['eventId'] === eventId) {
        return event;
      }
    }

    return null;
  }


    // Draws all seats on the map
    // =========================================================================== 
  _loadSeatsOnMap() {
    $(".section-seats").empty();
      
    if ( this.dataStorage.state == C.STATE_SEATS_UNGROUPED) {
      $(".visibleOnlyForUngrouped").show();
    } else {
      $(".visibleOnlyForUngrouped").hide();
    }

    this.allSeats = [];
    this.availableSeats = [];
    let seatKeys = this.dataStorage.GetCart().map(x => x.seatKey);
    let activeSeatKey = this.dataStorage.GetSelectedSeat().seatKey;


    let rotateSeat = 180;
    if (this.poi) {

      // Use the first row as a guideline
      var _this = this;
      var seatsOnRow = this.sectionData.seats.filter(function (aseat) { return aseat.row === _this.sectionData.seats[0].row; }); 
      var miny = seatsOnRow.reduce(function (prev, curr) {
        return Number(prev.y) < Number(curr.y) ? prev : curr;
      });
      var maxy = seatsOnRow.reduce(function (prev, curr) {
        return Number(prev.y) > Number(curr.y) ? prev : curr;
      });
      var minx = seatsOnRow.reduce(function (prev, curr) {
        return Number(prev.x) < Number(curr.x) ? prev : curr;
      });
      var maxx = seatsOnRow.reduce(function (prev, curr) {
        return Number(prev.x) > Number(curr.x) ? prev : curr;
      });

      let dx = Math.abs(minx.x - maxx.x);
      let dy = Math.abs(miny.y - maxy.y);

        if (dx > 5 && dy > 5) { // Slanted bleachers
      
        if (0 < this.seatRotation && this.seatRotation < 90) {
          // TOP RIGHT
          rotateSeat = 225;
        }
        if (-270 < this.seatRotation && this.seatRotation < -180) {
          // BOTTOM RIGHT
          rotateSeat = -45;
        }

        if (-180 < this.seatRotation && this.seatRotation < -90) {
          // BOTTOM LEFT
          rotateSeat = 45;
        }

        if (-90 < this.seatRotation && this.seatRotation < 0) {
          // TOP LEFT
          rotateSeat = 135;
        }

        } else if (dx > 5) { // horizontal bleacher

        if (this.section.arenaCords.y - this.poi.y > 0) {
          rotateSeat = 0;
        } else {
          rotateSeat = 180;
        }

        } else if (dy > 5) { // vertical bleacher

        if (this.section.arenaCords.x - this.poi.x > 0) {
          rotateSeat = 270;
        } else {
          rotateSeat = 90;
        }

      }

    }

    let icon = this.section.svgIcon;
    if (icon == undefined || icon == null || icon == "") {
      icon = window.arenaInfo.svgIcon;
    }

    // Set icons on icondescriptionbar    
    let svgSeatIcon = $(".section-container-icons .mapicon");
    switch (icon) {
      case "circle":
        svgSeatIcon.attr("d", "M 0,0 m -10, 0 a 10, 10 0 1,0 20,0 a 10,10 0 1,0 -20,0");
        svgSeatIcon.attr('fill', "transparent");
        svgSeatIcon.attr('transform', "");
        break;
      default:
        svgSeatIcon.attr("d", "M2.62,12.4l13.2,0m1.62,1V7.74M.5,13.43S.5,15.5,9,15.5s8.47-2.07,8.47-2.07M.5,7.74v5.69M15.85,8.26H18M.5,8.26H2.62m12.7,4.65V3A9.59,9.59,0,0,0,2.49,3l.13,10"); //Set path's data     
        svgSeatIcon.attr('transform-origin', "0 0");
        svgSeatIcon.attr('fill', "#ffffff");
        svgSeatIcon.attr('transform', "translate(-9,-9), rotate(0)");                 
    } 



    for (let i = 0; i < this.sectionData.seats.length; i++) {
      let seat = new Seat({
        data: this.sectionData.seats[i],
        offset: this.section.arenaCords,
        leftMargin: 0,
        topMargin: 0,
        rotate: rotateSeat,
        iconpath: icon
      });

      this.allSeats.push(seat);      

      let available = true;
      
      let availableSeats = this.sectionData.seats[i].oitems;
      if (availableSeats != null && availableSeats.length > 0) {

        if (this.dataStorage.state == C.STATE_SEATS_GROUPED) {
          // all tickets must be allowed to sit at the venue
          for (var i2 = 0; i2 < this.dataStorage.GetCart().length; i2++) {
            if (!availableSeats.includes(this.dataStorage.GetCart()[i2].id)) {
              seat.available = false;
              available = false;
              seat.unavailable();
              continue;
            }
          }
        } else {
          // active ticket must be allowed to sit in the seat
          if (!availableSeats.includes(this.dataStorage.GetSelectedSeat().id)) {
            seat.available = false;
            available = false;
            seat.unavailable();
            continue;
          }
        }
      } else {
        seat.available = false;
        seat.unavailable();
        available = false;
      }


      // Check if it is in the cart
      if (seatKeys.includes(seat.seatKey)) {
        if (this.dataStorage.state == C.STATE_SEATS_UNGROUPED && activeSeatKey == seat.seatKey) {
          seat.active(); // Mark active seat
        } else {
          seat.available = false;
          seat.picked();
        }        
      }
      if (!available) {
        seat.available = false;
        seat.unavailable();
        continue;
      }

        let _this = this;
      $(seat.el).on('click touchend', function(e) {        
        if (_this.isPinching) { return; }
        if (_this.isIOS12) {
        if (_this.isDragging) { return; }
        } else {
          e.stopPropagation();
          e.preventDefault();
          e.stopImmediatePropagation();
        }
        _this._clearError();
        _this._hoverSeatsOnMap(seat);
        if (seat.isAvailableForSeating()) {
          _this._onSelectSeat(seat);          
        }
      });


      $(seat.el).on("mouseover", function () {
        _this._hoverSeatsOnMap(seat);            
      });
      $(seat.el).on("mouseout", function () {
        _this._clearHoverSeatsOnMap(seat);            
      });




      this.availableSeats.push(seat);
    }   
  }

    sortHelper(a, b) {
        if (a.num < b.num) {
            return -1;
        }
        if (a.num > b.num) {
            return 1;
        }
        return 0;
    }
    _clearHoverSeatsOnMap(seat) {
        var seatsOnRow = this.allSeats.filter(function (aseat) { return aseat.row === seat.row; }).sort(this.sortHelper);       
        for (var i = 0; i < seatsOnRow.length; i++) {
            seatsOnRow[i].clearHover();
        }
    }

      //
    /// Function to show hover seats
    //
  _hoverSeatsOnMap(seat) {
    let hoverlist = [];
    
    var seatsOnRow = this.allSeats.filter(function (aseat) { return aseat.row === seat.row; });//.sort(this.sortHelper);
    var allRowLength = seatsOnRow.length;
    var min = seatsOnRow.reduce(function (prev, curr) {
      return prev.x < curr.x ? prev : curr;
    });
    var max = seatsOnRow.reduce(function (prev, curr) {
      return prev.x > curr.x ? prev : curr;
    });    
    if (min.num > max.num) {
      seatsOnRow = seatsOnRow.sort(this.sortHelper).reverse();
    } else {
      seatsOnRow = seatsOnRow.sort(this.sortHelper);
    }
    var allInRow = seatsOnRow;

    let idx = seatsOnRow.indexOf(seat);
    if (idx === -1) return hoverlist;
    let startid = 0;
    for (var i = 0; i < idx; i++) {
      if (this.state == C.STATE_SEATS_UNGROUPED) {
        if (!seatsOnRow[idx - i].available) {
          startid = idx - i + 1;
          break;
        }
      } else {
        if (!seatsOnRow[idx - i].available && !seatsOnRow[idx - i].isSelected()) {
          startid = idx - i + 1;
          break;
        }
      }
    }
    var endId = seatsOnRow.length;
    for (var i = idx; i < seatsOnRow.length; i++) {
      if (this.state == C.STATE_SEATS_UNGROUPED) {
        if (!seatsOnRow[i].available) {
          endId = i;
          break;
        }
      } else {
        if (!seatsOnRow[i].available && !seatsOnRow[i].isSelected()) {
          endId = i;
          break;
        }
      }
    }
    seatsOnRow = seatsOnRow.slice(startid, endId);
    // adjustments of idx
    if (startid > 0) { idx = idx - startid; } 
    if (idx === -1) { idx = 0 };
    let _this = this;
    let cnt = this.dataStorage.GetCart().length;   
    if (this.state == C.STATE_SEATS_GROUPED) {         
    } else {
      cnt = 1;      
    }

    if (cnt > seatsOnRow.length) {
      for (var i = idx; i < seatsOnRow.length; i++) {
        seatsOnRow[i].notAvailableForSeating();
      }
      return hoverlist;
    }

    //Efter Sista stolen fall
    if (idx + cnt >= seatsOnRow.length) {
      idx = seatsOnRow.length - cnt;
    }


    if (this.seatDistancing > 0) {
      //
      // CORONA DISTANCING CASE
      //
       
      // case: skip first
      if (startid == 0) {
        if (this.state == C.STATE_SEATS_UNGROUPED) {
          if (idx == 0 && !seatsOnRow[0].isSelected()) {
            for (var i = idx; i < idx + cnt; i++) {
              seatsOnRow[i].notAvailableForSeating();
            }
            return hoverlist;
          }
        } else {
          if (idx == 0) {
            for (var i = idx; i < idx + cnt; i++) {
              seatsOnRow[i].notAvailableForSeating();
            }
            return hoverlist;
          }
        }
      } else {
        // By setting
        
        if (this.state == C.STATE_SEATS_UNGROUPED) {
          var isFirstUsersSelected = allInRow[startid - 1].isSelected();
          if (!isFirstUsersSelected && idx < this.seatDistancing) {
            for (var i = idx; i < idx + cnt; i++) {
              seatsOnRow[i].notAvailableForSeating();
            }
            return hoverlist;
          }
        } else {
          if (idx < this.seatDistancing) {
            for (var i = idx; i < idx + cnt; i++) {
              seatsOnRow[i].notAvailableForSeating();
            }
            return hoverlist;
          }
        }
      }

      //case: last chair
      if (endId == allRowLength) {
        if (idx + cnt == seatsOnRow.length) {
          for (var i = idx; i < seatsOnRow.length; i++) {
            seatsOnRow[i].notAvailableForSeating();
          }
          return hoverlist;
        }
      } else {
        // By setting
        var isLastUsersSelected = endId + 1 < allRowLength ? allInRow[endId].isSelected() : true;
        if (!isLastUsersSelected && idx + cnt + this.seatDistancing > seatsOnRow.length) {
          for (var i = idx; i < seatsOnRow.length; i++) {
            seatsOnRow[i].notAvailableForSeating();
          }
          return hoverlist;
        }
      }
    }






    if (this.useSeatsLimitRule && this.seatDistancing == 0) {

      // Rules

      // Case: skip first seat
      if (this.state == C.STATE_SEATS_UNGROUPED) {
        if (idx == 1 && !seatsOnRow[0].isSelected()) {
          for (var i = idx; i < idx + cnt; i++) {
            seatsOnRow[i].notAvailableForSeating();
          }
          return hoverlist;
        }
      } else {
        if (idx == 1) {
          for (var i = idx; i < idx + cnt; i++) {
            seatsOnRow[i].notAvailableForSeating();
          }
          return hoverlist;
        }
      }


      // Case: skip last seat
      if (idx + cnt + this.seatDistancing == seatsOnRow.length - 1) {
        for (var i = idx; i < seatsOnRow.length - 1; i++) {
          seatsOnRow[i].notAvailableForSeating();
        }
        return hoverlist;
      }
    }

    for (var i = idx; i < idx + cnt; i++) {
      seatsOnRow[i].hover();
      hoverlist.push(seatsOnRow[i]);
    }     

    

    return hoverlist
  }

   // GROUPSELECTION
  _reserveSeats(seats, selectedSeat) {      
    if (!seats || !seats.length) {
      return false;
    }

    this._showLoader50();    
    let bodyData = [];    
    if (this.state == C.STATE_SEATS_UNGROUPED) {
      const index = this.dataStorage.GetSelectedSeatIndex();      
      bodyData.push({
        'OrderItemId': this.dataStorage.GetCart()[index].id,
        'SeatKey': selectedSeat.seatKey
      });
    } else {
      
      seats.map((seat, index) => {
        bodyData.push({
          'OrderItemId': this.dataStorage.GetCart()[index].id,
          'SeatKey': seat.seatKey
        });
      });
    }
    seats = seats.filter(val => val);
    const url = C.BASE_URL + C.RESERVE_SEATS_URL + this.sectionData.orderId;
    $.ajax({
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      type: 'POST',
      url: url,
      data: JSON.stringify({ List: bodyData }),
      success: (data, textStatus, xhr) => {
          this._onReserveSeatsComplete(data, textStatus, xhr, seats, selectedSeat);
        },
        error: (xhr, status, error) => {
            this._onReserveSeatsError(xhr, status, error, seats, selectedSeat);            
        }        
    });    
  }

 _onReserveSeatsError(xhr, status, error, seats, selectedSeat) {
    let errorEl = $('.section-container .error');
   errorEl.show();   

   this._hideLoader();   

      // CLEAR PICKED SEATS
      if (this.state == C.STATE_SEATS_UNGROUPED) {                    
          selectedSeat.unpicked();
          selectedSeat.error();
      } else {
          seats.forEach((seat, index) => {
              // one of the seats is bad, error-mark all
              seat.unpicked();
              seat.error();
          });
      }      
  }
 
  _onReserveSeatsComplete(data, textStatus, xhr, seats, selectedSeat) {
    if (parseInt(xhr.status) !== 200) {
        this._onReserveSeatsError(null, null, 'no 200 response code', selectedSeat);
    } else if (!data || !data.cartItems) {
        this._onReserveSeatsError(null, null, 'empty-cart', selectedSeat);
    } else if (data && data.cartItems && data.cartItems.length) {
      this.confirmedSeats = seats.slice();
      this._hideLoader();

            
        this.dataStorage.cart = data.cartItems;                 
      this.dataStorage.SetSelectedSeat(this.dataStorage.GetCart()[this._getNextSeatableIndex()]);
        this.props.onSeatClick(selectedSeat);

        
        $(".map .seat.picked").removeClass('picked');
        data.cartItems.forEach((seat) => {
            $("#" + seat.seatKey.replace(/\//g, "-"), svg).addClass('picked');            
        });


    } else {
        this._onReserveSeatsError(null, null, 'unknown error', selectedSeat);
    }
  }


   

   // Centers the chairs on the map
  _centerSeatsContainer() {
    if (this.section.startPosition) {
      var x = this.section.startPosition.x - this.section.arenaCords.x;
      var y = this.section.startPosition.y - this.section.arenaCords.y;
      $('.section-seats').css('left', -x);
      $('.section-seats').css('top', -y);
    } else {
      let x = Math.round(($('.section-container').width() - $('.section-seats').width()) * .5);
      let y = Math.round(($('.section-container').height() - $('.section-seats').height()) * .5);

      $('.section-seats').css('left', x);
      $('.section-seats').css('top', y);
    }
  }
  
  _checkUngroupedOption(numTickets) {
    if (!numTickets || numTickets <= 1) {
      $('.ungroup-option').hide();
    } else {
      $('.ungroup-option').show();
    }
  }

  _hideLoader() {    
    let loader = $('.section-container .loader');
    if (loader)
      loader.removeClass('opacity').fadeOut(300); 
  }

  _showLoader() {    
    let loader = $('.section-container .loader');
    loader.show();
  }
  _showLoader50() {
    let loader = $('.section-container .loader');
    loader.addClass('opacity').show();
  }
  _getArrowAngle(poi) {
    if (!poi)
      return null;
    let sectionPos = this.section.arenaCords;
    let sectionSz = this.section.dimensions;

    let sectionCenterX = sectionPos.x + sectionSz.x / 2;
    let sectionCenterY = sectionPos.y + sectionSz.y / 2;

    let distY = poi.y - sectionCenterY,
      distX = poi.x - sectionCenterX;
    let radians = Math.atan2(distY, distX);
    let degrees = radians * 180 / Math.PI;

    return degrees - 90;
  }

    // To clone an object and strip references
  _jsonClone(src) {
    return JSON.parse(JSON.stringify(src));
  }
    //
    // ON SELECT SEAT ON SVG-MAP
    // =========================================================================== 
  _onSelectSeat(seat) {
    if (this.isPinching) { this.isPinching = false; return };
    if (this.isDragging && this.dragCnt > 1) { return };
    if (this.lastPickedSeat.seatKey == seat.seatKey) { return };

    this.lastPickedSeat = seat;
    switch (this.state) {
      case C.STATE_SEATS_UNGROUPED:

        if (!seat.isAvailableForSeating()) return;

        const seats = this._jsonClone(this.dataStorage.GetCart());        
        const seatindex = this.dataStorage.GetSelectedSeatIndex();       
        seats[seatindex] = seat;        
        this._reserveSeats(seats, seat);

        break;

      default:  
        this._selectHoveredSeats(seat);
    }
  }

   
  _selectHoveredSeats(seat) {
    let seats = this._hoverSeatsOnMap(seat);
    // loop over the seats we selected
    let i = seats.length;
    while (i--) {
      seats[i].picked();
    }

    // make server call to make sure we actually can reserve selected seats
    this._reserveSeats(seats.slice());

  }



  _getNextSeatableIndex() {
      
        let currentIndex = this.dataStorage.GetSelectedSeatIndex();
        var nextIdx = currentIndex + 1;
        if (nextIdx > this.dataStorage.GetCart().length - 1) { nextIdx = 0; }

        var i = 0;
        var newIndexFound = false;

        do {
          var seatable = this.section.oitems.includes(this.dataStorage.GetCart()[nextIdx].id)
            if (seatable) {
                newIndexFound = true;
            } else {
                nextIdx++;
              if (nextIdx > this.dataStorage.GetCart().length - 1) {
                    nextIdx = 0;
                }
                i++;
            }
        } while (!newIndexFound && i < this.dataStorage.GetCart().length);
        return nextIdx;
  }
   

    _toggleMiniMap() {        
        var _this = this;
        $('#miniMap').slideToggle('fast', function () {
            var visible = $('#miniMap').is(":visible");
            $("#btnToggleMap").toggleClass('hide', !visible);  
            if (visible) { _this.updateMiniMapMarker(); }
        });
        
    }

   
    //
    // ON WINDOW RESIZE
    // =========================================================================== 
    onResize() {
        if (this.section) {
            this.resetViewport();
        }
    }


    //
    // RESET VIEWPORT
    // =========================================================================== 
    resetViewport() {

        if (this.pannable.tween) {
            this.pannable.tween.kill();
        }


        this.mapWidth = 0;
        this.mapHeight = 0;
        this.padding = { x: 100, y: 100 };

        var displayAreaWidth = $(".section-container")[0].clientWidth;
        var displayAreaHeight = $(".section-container")[0].clientHeight;
        if (displayAreaWidth == 0 || displayAreaHeight == 0) { return; }

        var displayRatio = displayAreaWidth / displayAreaHeight;
        var displayLeftMargin = 0;
        var displayTopMargin = 0;


        this.mapWidth = this.section.dimensions.x + 20;
        this.mapHeight = this.section.dimensions.y + 20;
        var mapRatio = this.mapWidth / this.mapHeight;

        this.mapWidth = this.mapHeight * displayRatio;
        if (this.mapWidth < this.section.dimensions.x) {            
            this.mapWidth = this.section.dimensions.x + 20;
            this.mapHeight = this.mapWidth / displayRatio;
        }

        // Adjust SVG after display view 
        displayLeftMargin = (this.mapWidth - this.mapHeight * mapRatio) / 2;


        displayLeftMargin = Math.max(0, displayLeftMargin);
        displayTopMargin = Math.max(0, displayTopMargin);

        $(".section-seats")[0].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");
        $(".section-seats")[1].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");



        // Keep scale zoom...
        this.viewBox.width = this.mapWidth;
        this.viewBox.height = this.mapHeight;
        this.viewBoxMini.width = this.mapWidth;
        this.viewBoxMini.height = this.mapHeight;

        this.cachedViewBox.width = this.mapWidth;
        this.cachedViewBox.height = this.mapHeight;

        this.viewBox.x = this.cachedViewBox.x;
        this.viewBox.y = this.cachedViewBox.y;
        this.viewBoxMini.x = this.cachedViewBox.x;
        this.viewBoxMini.y = this.cachedViewBox.y;

        this.updateMiniMapMarker();
         
        return;
         
    }
     

    //
    //ON PINCH START
    //===========================================================================
    _onPinchStart(ev) {
        try {
            this.isPinching = true;            

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;
            var pinchZoomOriginCalc = this.point.matrixTransform(this.svg.getScreenCTM().inverse());

            this.pinchZoomOrigin = {
                x: pinchZoomOriginCalc.x,
                y: pinchZoomOriginCalc.y
            };
        
            this.startPinch = {
                //ease: this.zoom.ease,
                x: this.viewBox.x,
                y: this.viewBox.y,
                width: this.viewBox.width,
                height: this.viewBox.height,
                //onComplete: function () { _this.updateMiniMapMarker() }
            };            

            //clearTimeout(this.tPinching);  
        } catch (e) {
            
        }
    }


   

    //
    //ON PINCH
    //===========================================================================
    _onPinch(ev) {        

        this.isPinching = true;
        var _this = this;

        if (_this.zoom.animation.isActive()) { return; }
       
        try {
          
            var scale = Math.round(1000 / ev.scale) / 1000; // Normalize

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;
            
            var x = this.startPinch.x - ((this.pinchZoomOrigin.x - this.startPinch.x)) * (scale - 1) 
            var y = this.startPinch.y - ((this.pinchZoomOrigin.y - this.startPinch.y)) * (scale - 1)       
                                    
            
            // Zoombounds
            let initW = this.viewBox.width;
            this.viewBox.width = (Math.min(this.startPinch.width * scale, this.cachedViewBox.width));
            this.viewBox.height = (Math.min(this.startPinch.height * scale, this.cachedViewBox.height));

            if (initW != this.viewBox.width) {
                this.viewBox.x = (Math.min(this.cachedViewBox.width - this.viewBox.width + this.padding.x, Math.max(x, -1 * this.padding.x)));
                this.viewBox.y = (Math.min(this.cachedViewBox.height - this.viewBox.height + this.padding.y, Math.max(y, -1 * this.padding.y)));
            }
            this.updateMiniMapMarker();           
             
        } catch (e) {
            console.log(e);            
        }

        return; 
    }


    //
    // ON PINCH OUT
    //===========================================================================
    _onPinchEnd(ev) {        
        var _this = this;
        clearTimeout(_this.tPinching);  
        _this.tPinching = setTimeout(function () {                
            _this.isPinching = false;
            _this.PinchCnt = 0; 
        }, 300);
    }


 
     
    //
    //ON BTN ZOOM
    //===========================================================================    
    btnZoom(ev) {

        var scale = ev.target.getAttribute("data-scale");

        var _this = this;
        var fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,
            onComplete: function () { _this.updateMiniMapMarker() }
        };

        // calculate center
        var x = this.viewBox.x - ((this.viewBox.x+this.viewBox.width / 2) - this.viewBox.x) * (scale - 1);
        var y = this.viewBox.y - ((this.viewBox.y+this.viewBox.height / 2) - this.viewBox.y) * (scale - 1);        
        this.viewBox.width *= scale;
        this.viewBox.height *= scale;

        // Zoombounds
        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

        this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
        this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));

        this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);
        

    }


    //
    // ON WHEEL
    //===========================================================================
    _onWheel(event) {        
        event.preventDefault();
        var normalized;
        var delta = event.wheelDelta;
        
        if (delta) {
            normalized = (delta % 120) == 0 ? delta / 120 : delta / 12;
        } else {
            delta = event.deltaY || event.detail || 0;
            normalized = -(delta % 3 ? delta * 10 : delta / 3);
        }

        var scaleDelta = normalized > 0 ? 1 / this.zoom.scaleFactor : this.zoom.scaleFactor;

        this.point.x = event.clientX;
        this.point.y = event.clientY;
        var startPoint = this.point.matrixTransform(this.svg.getScreenCTM().inverse());
        
        var _this = this;
        var fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,
            onComplete: function () { _this.updateMiniMapMarker() }
        };

         var x = this.viewBox.x - (startPoint.x - this.viewBox.x) * (scaleDelta - 1);
         var y = this.viewBox.y - (startPoint.y - this.viewBox.y) * (scaleDelta - 1);
         this.viewBox.width *= scaleDelta;
         this.viewBox.height *= scaleDelta;


        // Zoombounds         
         this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
         this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

         this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
         this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));
         
         this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);


    }

    //
    // SELECT DRAGGABLE
    // =========================================================================== 
    selectDraggable(event, _this, _this2) {        
        try {

          
            _this.startClient.x = _this2.pointerX;
            _this.startClient.y = _this2.pointerY;
            _this.startGlobal = _this.startClient.matrixTransform(_this.svg.getScreenCTM().inverse());

        
            // Right mouse button
            if (event.button === 2) {
                event.preventDefault();
                return;
            } else {

                gsap.set(this.proxy, {
                    x: _this2.pointerX,
                    y: _this2.pointerY
                });

              if (event.target != null && event.target.nodeName == "circle" || event.target.nodeName == "path") {
                    _this.pannable.enable().update();
                } else {
                    _this.pannable.enable().update().startDrag(event);
                }            

            }
        } catch (e) {            
        }
    } 

     

    //
    // on DRAG 
    // =========================================================================== 
    _onDrag(_this, _thisEl) {

        if (_this.isIOS12 && _this.isPinching) { return; }
        if (_this.zoom.animation.isActive()) { return; }
        if (!_this.pannable.isDragging) { return; }

        _this.point.x = _thisEl.x;
        _this.point.y = _thisEl.y;

        var moveGlobal = _this.point.matrixTransform(_this.svg.getScreenCTM().inverse());

        _this.viewBox.x -= (moveGlobal.x - _this.startGlobal.x);
        _this.viewBox.y -= (moveGlobal.y - _this.startGlobal.y);

        // Bound check
        _this.viewBox.x = Math.min(_this.cachedViewBox.width - _this.viewBox.width + this.padding.x, Math.max(_this.viewBox.x, -1 * this.padding.x));
        _this.viewBox.y = Math.min(_this.cachedViewBox.height - _this.viewBox.height + this.padding.y, Math.max(_this.viewBox.y, -1 * this.padding.y));

        _this.updateMiniMapMarker();
       
    }
    

    //
    // UPDATE MINIMAP MARKER
    // =========================================================================== 
    updateMiniMapMarker() {      
        if (this.svgMini.clientWidth == 0) {
            $(this.mapMarker).addClass("hidden");
            return;
        }

        $(this.mapMarker).removeClass("hidden");
        var mapSvgDomScale = this.svg.clientWidth / this.cachedViewBox.width;
        var mapRelationScaleWidth = this.svgMini.clientWidth / this.svg.clientWidth;
        var mapRelationScaleHeight = this.svgMini.clientHeight / this.svg.clientHeight;
        var zoomScale = this.viewBox.width / this.cachedViewBox.width;

        gsap.set(this.mapMarker, {
            x: this.viewBox.x * mapRelationScaleWidth * mapSvgDomScale,
            y: this.viewBox.y * mapRelationScaleHeight * mapSvgDomScale,
            width: Math.max(this.svg.clientWidth, 0) * mapRelationScaleWidth * zoomScale, 
            height: Math.max(this.svg.clientHeight, 0) * mapRelationScaleWidth * zoomScale, 
            force3D: true,
            transformOrigin: "left top"
        });
    }


    //
    // UPDATE MINIMAP
    // =========================================================================== 
    updateMiniMap(_this, _thisEl) {        
        var mapOrgScale = _this.svg.clientWidth / _this.cachedViewBox.width;
        var mapRelationScale = _this.svgMini.clientWidth / _this.svg.clientWidth;
        
        _this.viewBox.x = Math.min((_this.cachedViewBox.width - _this.viewBox.width + this.padding.x), Math.max(_thisEl.x / (mapRelationScale * mapOrgScale), -1 * this.padding.x));
        _this.viewBox.y = Math.min((_this.cachedViewBox.height - _this.viewBox.height + this.padding.y), Math.max(_thisEl.y / (mapRelationScale * mapOrgScale), -1 * this.padding.y));
    }
     
}

class Seat {
 
  constructor(props) {
    this.props = props;

    this.available = props.data.available;

    this.iconpath = props.iconpath;
    this.rotate = props.rotate;
    this.skey = props.data.skey;
    this.seatKey = props.data.skey;
    this.row = props.data.row;
    this.num = parseInt(props.data.skey.split('/')[2]);

      if (props.data.oitems != null) {
          this.tooltip = props.data.oitems.toString();
      }
            
    this.el = document.createElementNS("http://www.w3.org/2000/svg", "g");
    var svgSeat = document.createElementNS("http://www.w3.org/2000/svg", "path");
    this.clickArea = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    this.clickArea.setAttributeNS(null, 'fill', "transparent");    
    this.clickArea.setAttributeNS(null, 'cx', 0);
    this.clickArea.setAttributeNS(null, 'cy', 0);
    this.clickArea.setAttributeNS(null, 'r', '12');
    this.clickArea.setAttributeNS(null, 'opacity', 0.2);
    this.clickArea.setAttributeNS(null, 'stroke', "transparent");    
    
    var svgCross = document.createElementNS("http://www.w3.org/2000/svg", "path");
    svgCross.setAttribute("d", "M18.32.38l-18,15m0-15,18,15");
    svgCross.setAttribute("class", "cross");
    svgCross.setAttributeNS(null, 'transform', "translate(-9,-9)");


     
    switch (this.iconpath) {
      case "circle":
        svgSeat.setAttribute("d", "M 0,0 m -10, 0 a 10, 10 0 1,0 20,0 a 10,10 0 1,0 -20,0"); //Set path's data        
        svgSeat.setAttributeNS(null, 'fill', "transparent");
        break; 

      default:
        svgSeat.setAttribute("d", "M -6.38 3.4 l 13.2 0 m 1.62 1 V -1.26 M -8.5 4.43 S -8.5 6.5 0 6.5 s 8.47 -2.07 8.47 -2.07 M -8.5 -1.26 v 5.69 M 6.85 -0.74 H 9 M -8.5 -0.74 H -6.38 m 12.7 4.65 V -6 A 9.59 9.59 0 0 0 -6.51 -6 l 0.13 10"); //Set path's data
        svgSeat.setAttributeNS(null, 'transform', "rotate(" + this.rotate + ")");
        break;
                 
    } 
        
    this.radius = 12;
    this.x = this.props.leftMargin + 18 + parseInt((this.props.data.x - this.props.offset.x) - (this.radius * .5));
    this.y = this.props.topMargin + 18 + parseInt((this.props.data.y - this.props.offset.y) - (this.radius * .5));

    this.el.setAttribute("cx", this.x);
    this.el.setAttribute("cy", this.y);    
    this.el.setAttributeNS(null, 'transform', "translate(" + this.x + "," + this.y + ")");

    this.el.setAttribute("class", "seat");
    this.el.setAttribute("id", this.seatKey.replace(/\//g, "-"));
    this.el.setAttribute("data-id", this.seatKey);
    this.el.appendChild(this.clickArea);
    
    this.el.appendChild(svgSeat);
    this.el.appendChild(svgCross);

      if (this.tooltip != "") {          
          this.el.setAttribute("title", this.tooltip);
      }

      $('.section-seats').append(this.el);

      this.radius = "10";

    this._render();
  }

  transformTranslateX(translateX, translateY, rotationDegrees) {
    let rotationRadians = rotationDegrees * Math.PI / 180;
    return translateX * Math.cos(rotationRadians) - translateY * Math.sin(rotationRadians);
  }

  transformTranslateY(translateX, translateY, rotationDegrees) {
    let rotationRadians = rotationDegrees * Math.PI / 180;
    return translateX * Math.sin(rotationRadians) + translateY * Math.cos(rotationRadians);
  }


  isSelected() {
    return $(this.el).hasClass('picked');
  }
  isAvailableForSeating() {
    return !$(this.el).hasClass('notAvailableForSeating');
  }
  hover() {
    gsap.killTweensOf(this.el);
    $(this.el).addClass('hover');
  }
  clearHover() {
    gsap.killTweensOf(this.el);
    $(this.el).removeClass('hover');
    $(this.el).removeClass('notAvailableForSeating');
  }
  notAvailableForSeating() {
    gsap.killTweensOf(this.el);
    $(this.el).addClass('notAvailableForSeating');
  }
  picked() {
    gsap.killTweensOf(this.el);      
    this.selected = true;
    $(this.el).addClass('picked');
    $(this.el).removeClass('err');
  }

  active() {
    gsap.killTweensOf(this.el);
    $(this.el).removeClass('picked');
    $(this.el).addClass('active');
    $(this.el).removeClass('err');
  }



  // Already taken seats
  unavailable() { 
      gsap.killTweensOf(this.el);
      this.available = false;
      $(this.el).addClass('unavailable');
      $(this.el).removeClass('picked');
      $(this.el).removeClass('err');
  }

  loading() {
      gsap.killTweensOf(this.el);
      $(this.el).addClass('loading');
      $(this.el).removeClass('err');      
  }
  unpicked() {
    gsap.killTweensOf(this.el);
      $(this.el).removeClass('picked');
      $(this.el).removeClass('err');
  }

  error() {
      let spot = $(this.el);
      gsap.killTweensOf(this.el);
      
      spot.addClass('err');
      gsap.to(this.el, 2.3, {
          className: '+=unavailable', onComplete: function () {
              spot.removeClass('err');
              spot.unbind();             
          }
      });
  }

  getRadius() {
    return this.radius;
  }

    _render() {
        
        this.el.setAttribute("cx", this.x);
        this.el.setAttribute("cy", this.y);
       
        if (!this.available) {            
            $(this.el).addClass('unavailable');
        }
    }
}